class EPGController {
    constructor(model, view) {
        this._model = model;
        this._view = view;


        this._model.on('gotTime', result => {
            this._view.setState(result);
            this._model.getProgramGuide(result.time.split('T')[0]);
        })

        this._model.on('gotProgramGuide', result => {
            this._view.renderProgramGuide(result)
        })
    }
}


export default EPGController;